import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  BackButton,
  BackButtonWrapper,
  ClientCredentialsContentCard,
  ContentCard,
} from './ApiDefinitionTabLayout.styles';

interface ApiDefinitionTabLayoutProps {
  onBack: () => void;
  children: React.ReactNode;
  variant?: 'default' | 'clientCredentials';
}

export function ApiDefinitionTabLayout({
  onBack,
  children,
  variant = 'default',
}: ApiDefinitionTabLayoutProps) {
  const CardComponent =
    variant === 'clientCredentials'
      ? ClientCredentialsContentCard
      : ContentCard;

  return (
    <>
      <BackButtonWrapper>
        <BackButton
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          color="primary"
        >
          BACK TO APIs
        </BackButton>
      </BackButtonWrapper>
      <CardComponent>{children}</CardComponent>
    </>
  );
}
